export function slider($) {

	let blockSlider = $('.slider--block .owl-carousel').owlCarousel({
		items: 1,
		loop: true,
		nav: true,
		dots: false,
		autoplay: true,
		autoplayTimeout: 10000,
		navText: [
			'<i class="slider-fa-control fal fa-chevron-left"></i>',
			'<i class="slider-fa-control fal fa-chevron-right"></i>'
		],
		navElement: 'div',
		animateIn: 'fadeIn',
		animateOut: 'fadeOut',
	});

	let featuredSlider = $('.slider--featured .owl-carousel').owlCarousel({
		loop: true,
		items: 1,
		margin: 0,
		mouseDrag: false,
        autoplay: false,
		dots: false,
		nav: false,
	});

    let secondarySlider = $('.slider--secondary .owl-carousel').owlCarousel({
		loop: true,
		items: 2,
		margin: 0,
		mouseDrag: false,
        autoplay: false,
		dots: false,
		nav: false,
		startPosition: 1,
		margin: 2,
	});

	// Click listener for the slider block
	$('.carousel-btn').click(function (event) {
		// Sets the current active slide.
		blockSlider.trigger('to.owl.carousel', [$(this).index(), 300]);
	});

	$('.slider-posts .slider__controls-next').click(function() {
		featuredSlider.trigger('next.owl.carousel');
		secondarySlider.trigger('next.owl.carousel');
	});

	$('.slider-posts .slider__controls-prev').click(function() {
		featuredSlider.trigger('prev.owl.carousel');
		secondarySlider.trigger('prev.owl.carousel');
	});
}